import { LinearProgress, styled } from '@mui/material';

export const StyledLinearProgress = styled(LinearProgress)(
  ({ theme, height }) => ({
    borderRadius               : '50px',
    ...(height && { height: `${height}px` }),
    backgroundColor            : theme.palette.primary.grey3,
    marginTop                  : '4px',
    marginBottom               : '8px',
    '& .MuiLinearProgress-bar' : {
      backgroundColor : theme.palette.primary.greenPKD,
    },
  })
);
